import React, { useState, ChangeEvent, FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthApi from '../../api/platform/authApi';
import logo from '../../assets/images/logo-transparent.png';
import { useSystemError } from '../../components/Error/SystemErrorContext';
import styles from '../../css/auth/auth.module.css';
import { UserModel } from '../../models/platform/userModel';
import { ResponseErrorModel } from '../../models/system/responseErrorModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import { setCookie } from '../../utils/cookiesUtils';
import { handleError, mapResponseErrorToSystemError, mapUnknownErrorToSystemError } from '../../utils/errorUtils';
//test
const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const navigate = useNavigate();
  const [didErrorOccur, setDidErrorOccur] = useState(false);
  const { triggerSystemError } = useSystemError();

  const fetchLoginUser = async () => {
    try {
      const user: UserModel = { email, password };
      const response = await AuthApi.loginUser(user);

      if (response.success) {
        const data = (response as ResponseSuccessModel).data;
        const platform_token = data.platform_token;
        setCookie('platform_token', platform_token);
        navigate('/main');
      } else {
        handleError(mapResponseErrorToSystemError(response as ResponseErrorModel), setErrorMessage, setDidErrorOccur, triggerSystemError);
      }
    } catch (error: any) {
      handleError(mapUnknownErrorToSystemError(error, false), setErrorMessage, setDidErrorOccur, triggerSystemError);
    }
  };

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setErrorMessage(null);
  };

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    setErrorMessage(null);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();

      if (!email) {
        setErrorMessage('Please enter your email address');
        return;
      }
      if (!password) {
        setErrorMessage('Please enter your password');
        return;
      }

      await fetchLoginUser();
    } catch (error) {
      handleError(mapUnknownErrorToSystemError(error, false), setErrorMessage, setDidErrorOccur, triggerSystemError);
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.card}>
        <img src={logo} alt="Medical Device IQ" className={styles.logo} />
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <input
              type="email"
              id="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="Email"
            />
          </div>
          <div className={styles.formGroup}>
            <input
              type="password"
              id="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder="Password"
            />
          </div>
          <div className={styles.forgotPassword}>
            <Link to="/auth/password/request-reset">Forgot Password?</Link>
          </div>
          <button type="submit">Log In</button>
          {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
        </form>
      </div>
      <div className={styles.registerLinkOuter}>
        <p>Don't have an account?  <Link to="/auth/register">Sign Up</Link></p>
      </div>
    </div>
  );
};

export default Login;
